import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { ViewPackage } from 'admin/components/Offer/ViewPackage';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { Images } from 'assets/images';
import { ModalWrapper } from 'admin/components/Requsts/styled';
import { ModalContainer } from 'admin/components/Packages/styled';
import { SampleDiv } from 'admin/layout/styled';
import {
  MainOfferImage,
  OffersWrapper,
  UserOffer,
  AboutDescription,
  TitleAndButtonsWrapper,
  TourTitle,
  SmallButtonsWrapper,
  EditNoteDeleteButton,
  ActionsImage,
  DescriptionOfOffer,
} from './styled';

export const OfferSection = ({ offerData, setOfferData, setTableOptions }) => {
  const [viewData, setViewData] = useState([]);
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const deleteItem = (element) => {
    setTableOptions((prev) => [...prev, element]);
    setOfferData((prevTableOptions) =>
      prevTableOptions.filter((items) => items.id !== element.id),
    );
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const openPackageModal = (element) => {
    setIsOpen((prev) => !prev);
    setViewData(element);
  };

  return (
    <OffersWrapper>
      {isOpen && (
        <ModalContainer>
          <SampleDiv ref={ref}>
            <ModalWrapper>
              <ViewPackage viewData={viewData} closeModal={closeModal} />
            </ModalWrapper>
          </SampleDiv>
        </ModalContainer>
      )}
      {offerData.map((element) => (
        <UserOffer key={uuid()}>
          <MainOfferImage image={element.image} />
          <AboutDescription>
            <TitleAndButtonsWrapper>
              <TourTitle>{element.title}</TourTitle>
              <SmallButtonsWrapper>
                <EditNoteDeleteButton>
                  <ActionsImage
                    src={Images.deleteButton}
                    onClick={() => deleteItem(element)}
                  />
                </EditNoteDeleteButton>
                <EditNoteDeleteButton>
                  <ActionsImage
                    src={Images.eyeSilverIcon}
                    onClick={() => openPackageModal(element)}
                  />
                </EditNoteDeleteButton>
                <EditNoteDeleteButton>
                  <ActionsImage src={Images.noteButton} />
                </EditNoteDeleteButton>
              </SmallButtonsWrapper>
            </TitleAndButtonsWrapper>
            <DescriptionOfOffer>{element.description}</DescriptionOfOffer>
          </AboutDescription>
        </UserOffer>
      ))}
    </OffersWrapper>
  );
};
